import script from "./ui-select.vue?vue&type=script&setup=true&lang=js"
export * from "./ui-select.vue?vue&type=script&setup=true&lang=js"

import "./ui-select.vue?vue&type=style&index=0&id=4ada6215&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.21_vue@3.5.21_webpack@5.106.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ada6215"]])

export default __exports__